document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener('rebuy:smartcart.show', (event) => {
    document.querySelectorAll('.rebuy-cart__flyout-item-discount-message').forEach(item => {
      item.style.display = 'none';
    });
    addDiscountPercent();
  });
});


function addDiscountPercent() {
    document.querySelectorAll('.percentage-off').forEach(item => {
      item.remove();
    });
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        cart.items.forEach(item => {
          const discountAlloc = item.line_level_discount_allocations?.[0]?.discount_application;
          if (discountAlloc?.value_type === 'percentage' && item.properties['_rc_bundle']) {
            const discountValue = parseInt(discountAlloc.value);
  
            const bundleItem = document.querySelectorAll(`.product-${item.handle}[class*="property-_rc_bundle"]`);
            
            if (bundleItem) {
              const compareAtPrice = bundleItem[0].querySelectorAll('.rebuy-cart__flyout-item-price');
              const spanPercentage = document.createElement('span');
              spanPercentage.textContent = ` ${discountValue}% OFF`; 
              const span = document.createElement('span');
              span.classList.add('sale', 'percentage-off');
              span.appendChild(spanPercentage);
              compareAtPrice[0].firstElementChild.appendChild(span);
            }
          }
        });
      })
      .catch(error => {
        console.error('Error:', error);
      });
}
